// import React from 'react';
import Menu from './menu.jsx';
import { AuthDelegate } from '../utils';

class AuthMenu extends Menu {
    constructor(props) {
        super(props);

        if (!props.user) {
            throw new Error('AuthMenu requires prop \'user\'');
        }
    }
    shouldRenderItem(item = {}) {
        const auth = item.auth || {};
        let shouldRender = true;

        if (auth.loginState) {
            shouldRender = shouldRender && AuthDelegate.userHasLoginState(auth.loginState)(this.props.user);
        }

        if (auth.approvalStatus) {
            shouldRender = shouldRender && AuthDelegate.userHasApprovalState(auth.approvalStatus)(this.props.user);
        }

        return shouldRender;
    }
}

export default AuthMenu;



// WEBPACK FOOTER //
// ./web-app/components/auth-menu.jsx